import { useState, useEffect, useRef } from 'react';
import { AIIcon } from '../components/Icons';
import { fetchPortfolio, authHeaders } from '../utils/api';

function AIAnalystChat() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [portfolio, setPortfolio] = useState([]);
  const chatRef = useRef(null);

  useEffect(() => {
    fetchPortfolio().then(setPortfolio);
  }, []);

  useEffect(() => {
    if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [messages]);

  const portfolioContext = portfolio.length > 0
    ? portfolio.map(h => `${h.ticker} (${h.shares} shares, bought at $${h.buy_price})`).join(', ')
    : 'No holdings yet';

  async function handleSend() {
    if (!input.trim() || loading) return;
    const userMsg = { role: 'user', content: input };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setLoading(true);

    try {
      const res = await fetch('/api/chat', {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          message: input,
          history: messages,
          portfolio_context: portfolioContext,
        }),
      });
      const data = await res.json();
      if (data.error) {
        setMessages(prev => [...prev, { role: 'assistant', content: `Sorry, I encountered an error: ${data.error}` }]);
      } else {
        setMessages(prev => [...prev, { role: 'assistant', content: data.reply }]);
      }
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: 'Unable to reach the AI service. Please try again.' }]);
    }
    setLoading(false);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); }
  }

  return (
    <div>
      <div className="page-title">
        <AIIcon size={28} color="#00ff9d" />
        <h1>AI Analyst Chat</h1>
      </div>
      <p className="hero-subtitle">Ask anything about your portfolio, markets, or individual stocks — powered by Grok</p>

      <div className="chat-container" ref={chatRef}>
        {messages.map((m, i) => (
          <div key={i} className={`chat-message ${m.role}`}>
            <div className="role">{m.role === 'user' ? 'You' : 'AI Analyst'}</div>
            <div className="content" style={{ whiteSpace: 'pre-wrap' }}>{m.content}</div>
          </div>
        ))}
        {loading && (
          <div className="chat-message assistant">
            <div className="role">AI Analyst</div>
            <div className="content" style={{ color: '#64748b' }}>
              <span className="spinner" style={{ marginRight: 8 }} />Analyzing...
            </div>
          </div>
        )}
        {messages.length === 0 && !loading && (
          <div className="glass-card empty-state" style={{ padding: '40px 20px' }}>
            <p style={{ color: '#475569' }}>Start a conversation — ask about your portfolio, NASDAQ, TSX, or any stock.</p>
          </div>
        )}
      </div>

      <div className="chat-input-row">
        <input className="input-field" value={input} onChange={e => setInput(e.target.value)}
          onKeyDown={handleKeyDown} placeholder="Ask about your portfolio, NASDAQ, TSX, or any stock..." disabled={loading} />
        <button className="btn-primary" onClick={handleSend} disabled={loading}>
          {loading ? 'Sending...' : 'Send'}
        </button>
      </div>

      {messages.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <button className="btn-secondary" onClick={() => setMessages([])}>Clear Chat History</button>
        </div>
      )}
    </div>
  );
}

export default AIAnalystChat;
